import React from "react";
import styled, { css } from "styled-components";

interface IProps {
    isOpen?: boolean;
    size?: number;
}

const PlusMinusWrapper = styled.div<{ $size: number }>`
    ${({ $size }) => css`
        width: ${$size}px;
        height: ${$size}px;
        max-width: ${$size}px;
        max-height: ${$size}px;
    `}

    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.v2.colors["text-primary-300"]};
    padding: 4px;
    position: relative;
`;

const PlusMinus = styled.div<IProps>`
    width: 10px;
    height: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &:before,
    &:after {
        content: "";
        position: absolute;
        background-color: ${({ theme }) => theme.v2.colors["text-primary-300"]};
        transition: transform 0.25s ease-out;
        border-radius: 2px;
    }

    &::before {
        top: 0;
        left: 50%;
        width: 2px;
        height: 100%;
        margin-left: -1px;
        ${({ isOpen }) => isOpen && "transform: rotate(90deg);"}
    }

    &::after {
        top: 50%;
        left: 0;
        width: 100%;
        height: 2px;
        margin-top: -1px;
    }
`;

const PlusMinusIcon: React.FC<IProps> = ({ size = 22, isOpen }) => {
    return (
        <PlusMinusWrapper $size={size}>
            <PlusMinus isOpen={isOpen} />
        </PlusMinusWrapper>
    );
};

export default PlusMinusIcon;
